<template>
  <empty-page fillHeight>
    <v-layout column justify-center align-center>
      <div class="errorCode primary--text">404</div>
      <p class="errorDesc">
        Page not found
      </p>
      <v-btn :to="{ name: 'dashboard' }">Go to Dashboard</v-btn>
    </v-layout>
  </empty-page>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.errorCode {
  font-size: 5em;
}

.errorDesc {
  font-size: 1.5em;
}
</style>
